import {isNil} from 'ramda';

import type {FinancingControlSelection} from './getFinancingControlLimits';

export interface DownPaymentAdjustment {
  fromPercentage: number;
  toPercentage: number;
  reason: 'FLOOR' | 'BALLOON_CAP';
}

export function getDownPaymentAdjustment(
  requested: FinancingControlSelection,
  constrained: FinancingControlSelection
): DownPaymentAdjustment | null {
  const fromPercentage = requested.downPaymentPercentage;
  const toPercentage = constrained.downPaymentPercentage;

  if (isNil(fromPercentage) || isNil(toPercentage) || fromPercentage === toPercentage) {
    return null;
  }

  return {
    fromPercentage,
    toPercentage,
    reason: toPercentage > fromPercentage ? 'FLOOR' : 'BALLOON_CAP',
  };
}
